import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarCheck, Images, MessageCircle, ShieldCheck, Phone } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const SLIDES = [
  'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=1920&q=85&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1606265752439-1f18756aa5fc?w=1920&q=85&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=1920&q=85&auto=format&fit=crop',
];

const HeroSection = ({ clinic }) => {
  const { t } = useLanguage();
  const [heroIndex, setHeroIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setHeroIndex((prev) => (prev + 1) % SLIDES.length);
    }, 5500);
    return () => clearInterval(id);
  }, []);

  const waNumber = String(clinic?.clinic_whatsapp || '').replace(/[^\d]/g, '');
  const phoneNumber = String(clinic?.clinic_phone || '').replace(/[^\d+]/g, '');

  return (
    <section className="hero-section" id="home">
      <div className="hero-slider-bg">
        {SLIDES.map((src, i) => (
          <div
            key={src}
            className={`hero-slide ${i === heroIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
      </div>
      <div className="hero-overlay" />

      <div className="hero-content container-premium">
        <div className="hero-grid">
          <div className="hero-text">
            <span className="badge-crystal-dark">
              <ShieldCheck size={14} style={{ marginRight: 6 }} />
              {t('hero.badge', 'ISO 9001 Certified Clinic')}
            </span>
            <h1 className="hero-title">
              {t('hero.title', 'Your New Smile Starts in Alanya')}
            </h1>
            <p className="hero-subtitle">
              {t('hero.subtitle', 'World-class dental care with all-inclusive packages — save up to 70% vs UK/EU prices.')}
            </p>

            <div className="hero-cta-row">
              <Link to="/appointment" className="btn-accent">
                <CalendarCheck size={16} /> {t('hero.ctaPrimary', 'Free Online Consultation')}
              </Link>
              {waNumber && (
                <a
                  href={`https://wa.me/${waNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-glass"
                >
                  <MessageCircle size={16} /> {t('hero.ctaSecondary', 'WhatsApp Chat')}
                </a>
              )}
              <Link to="/gallery" className="btn-ghost-light">
                <Images size={16} /> {t('hero.ctaTertiary', 'View Smile Gallery')}
              </Link>
            </div>

            <div className="hero-meta">
              <span className="hero-online-dot" />
              <span>{t('hero.online', 'Online now — replies in ~5 min')}</span>
              {phoneNumber && (
                <a href={`tel:${phoneNumber}`} className="hero-phone">
                  <Phone size={13} /> {clinic?.clinic_phone}
                </a>
              )}
            </div>

            <div className="hero-dots">
              {SLIDES.map((_, dot) => (
                <button
                  key={dot}
                  type="button"
                  className={`hero-dot ${dot === heroIndex ? 'active' : ''}`}
                  onClick={() => setHeroIndex(dot)}
                  aria-label={`Slide ${dot + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
